import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import AcceptTerms from '@/views/AcceptTerms.vue';

export const acceptTermsRoute: RouteConfig = {
  path: '/accept-terms/:token',
  name: 'acceptTerms',
  component: AcceptTerms,
  beforeEnter: (to: any, from: any, next: any) => {
    store
      .dispatch('terms/current', { required: true })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.terms.listError' }));
  }
};
